/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_User_List_Column_EmailInputs */

const en_admin_user_list_column_email = /** @type {(inputs: Admin_User_List_Column_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`email`)
};

const de_admin_user_list_column_email = /** @type {(inputs: Admin_User_List_Column_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail`)
};

/**
* | output |
* | --- |
* | "email" |
*
* @param {Admin_User_List_Column_EmailInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_user_list_column_email = /** @type {((inputs?: Admin_User_List_Column_EmailInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_User_List_Column_EmailInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_user_list_column_email(inputs)
	return en_admin_user_list_column_email(inputs)
});